import React from "react";
import {
	Box,
	Button,
	FormControl,
	FormLabel,
	Grid,
	IconButton,
	TextField,
	Typography,
	useTheme,
} from "@mui/material";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import LoopOutlinedIcon from "@mui/icons-material/LoopOutlined";
import AutorenewIcon from "@mui/icons-material/Autorenew";

function LogoAndTheme({
	loadingImg,
	handleChange,
	color1,
	color2,
	color3,
	color4,
	setColor1,
	setColor2,
	setColor3,
	setColor4,
}) {
	const theme = useTheme();

	return (
		<Box
			display={"flex"}
			justifyContent={"space-around"}
			sx={{
				[theme.breakpoints.down("md")]: {
					flexDirection: "column",
					alignItems: "center",
				},
			}}>
			<Box display={"flex"} flexDirection={"column"} mb={2}>
				<IconButton
					sx={{
						borderRadius: "8px",
						border: "1px dashed #d9d9d9",
						width: "150px",
						height: "130px",
						my: 1,
					}}
					component="label">
					<Box className="d-flex-column">
						{loadingImg ? <LoopOutlinedIcon /> : <AddCircleOutlineOutlinedIcon />}
						<Typography mt={2} fontSize={18} fontWeight={"bold"}>
							بارگذاری لوگو
						</Typography>
					</Box>
					<TextField
						type="file"
						hidden
						sx={{ display: "none" }}
						onChange={info => {
							handleChange(info);
						}}
						name="[licenseFile]"
					/>
				</IconButton>
				<Button
					variant="contained"
					onClick={() => {
						setColor1("#35284A");
						setColor2("#FB7D79");
						setColor3("#ffffff");
						setColor4("#35284A");
					}}
					sx={{ width: "150px", mt: 1, mb: 1 }}
					startIcon={<AutorenewIcon sx={{ ml: 1 }} />}>
					بازنشانی تم تراز
				</Button>
			</Box>
			<Grid container spacing={2}>
				<Grid item xs={6} className="d-flex">
					<FormControl className="d-flex" sx={{ m: 0.8 }}>
						<FormLabel sx={{ fontWeight: "bold", mb: 0.2, fontSize: 15 }}>
							انتخاب رنگ اول
						</FormLabel>
						<TextField
							value={color1 && color1}
							onChange={e => {
								setColor1(e.target.value);
							}}
							type={"color"}
							variant="outlined"
							sx={{
								border: "none",
								"& input": {
									width: "50px",
									height: "50px",
									p: 0.5,
								},
							}}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={6} className="d-flex">
					<FormControl className="d-flex" sx={{ m: 0.8 }}>
						<FormLabel sx={{ fontWeight: "bold", mb: 0.2, fontSize: 15 }}>
							انتخاب رنگ دوم
						</FormLabel>
						<TextField
							value={color2 && color2}
							onChange={e => {
								setColor2(e.target.value);
							}}
							type={"color"}
							variant="outlined"
							sx={{
								border: "none",
								"& input": {
									width: "50px",
									height: "50px",
									p: 0.5,
								},
							}}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={6} className="d-flex">
					<FormControl className="d-flex" sx={{ m: 0.8 }}>
						<FormLabel sx={{ fontWeight: "bold", mb: 0.2, fontSize: 15 }}>
							انتخاب رنگ متن
						</FormLabel>
						<TextField
							value={color3 && color3}
							onChange={e => {
								setColor3(e.target.value);
							}}
							type={"color"}
							variant="outlined"
							sx={{
								border: "none",
								"& input": {
									width: "50px",
									height: "50px",
									p: 0.5,
								},
							}}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={6} className="d-flex">
					<FormControl className="d-flex" sx={{ m: 0.8 }}>
						<FormLabel sx={{ fontWeight: "bold", mb: 0.2, fontSize: 15 }}>
							انتخاب رنگ پس زمینه{" "}
						</FormLabel>
						<TextField
							value={color4 && color4}
							onChange={e => {
								setColor4(e.target.value);
							}}
							type={"color"}
							variant="outlined"
							sx={{
								border: "none",
								"& input": {
									width: "50px",
									height: "50px",
									p: 0.5,
								},
							}}
						/>
					</FormControl>
				</Grid>
			</Grid>
		</Box>
	);
}

export default LogoAndTheme;
